<template>
    <v-row
        style="width: 670px; height: 200px; background-color: #140542; color: white;"
        class="px-0 py-1  ml-1"
        align="center"
        justify="center"
    >
        <v-col
            cols="12"
            class="px-0 py-0 my-0 d-flex align-center justify-center"
        >
            <div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;">
                <v-avatar style="border-radius: 10px;" size="80px" color="white" class="mr-5">
                    <img :src="getCountryFlagUrl(match.team1.name)" height="80px" width="auto">
                </v-avatar>
                <div class="circular-border">
                    <v-progress-circular
                        :size="150"
                        :width="20"
                        :value="(getMade(match.team1) / getAttempts(match.team1)).toFixed(2) * 100"
                        :color="match.team1.color"
                        style="font-size: 1.5rem;"
                    >
                        <div class="white--text">
                            ({{ getMade(match.team1) }} / {{ getAttempts(match.team1) }})
                        </div>
                        <div class="white--text">
                            {{ ((getMade(match.team1) / getAttempts(match.team1)).toFixed(2) * 100).toFixed(0) }}%
                        </div>
                    </v-progress-circular>
                </div>
                <span class="px-0 mx-5 custom-teal-text font-weight-bold" style="font-size: 2rem;">
                    {{ type }}
                </span>
                <div class="circular-border">
                    <v-progress-circular
                        :size="150"
                        :width="20"
                        :value="(getMade(match.team2) / getAttempts(match.team2)).toFixed(2) * 100"
                        :color="this.match.team2.color"
                        style="font-size: 1.5rem;"
                    >
                        <div class="white--text">
                            ({{ getMade(match.team2) }} / {{ getAttempts(match.team2) }})
                        </div>
                        <div class="white--text">
                            {{ ((getMade(match.team2) / getAttempts(match.team2)).toFixed(2) * 100).toFixed(0) }}%
                        </div>
                    </v-progress-circular>
                </div>
                <v-avatar style="border-radius: 10px;" size="80px" color="white" class="ml-5">
                    <img
                        :src="getCountryFlagUrl(match.team2.name)"
                        width="80px"
                        height="auto"
                        contain
                    >
                </v-avatar>
            </div>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: null
            },
            match: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        watch: {
            match: {
                handler() {
                    this.$forceUpdate()
                },
                deep: true,
                immediate: true
            }
        },
        created() {
            this.$emit('updateEvents')
        },
        updated() {
            this.$emit('updateEvents')
        },
        methods: {
            getCountryFlagUrl(teamName) {
                const country = teamName.split('-')[0].trim()
                console.log('Country:', country)
                const countryCode = this.$countries.getAlpha2Code(country, 'en')
                console.log('Country code:', countryCode)
                if (country === 'MOLDOVA') {
                    return 'https://flagcdn.com/w320/md.png'
                }
                if (!countryCode) {
                    return `https://flagcdn.com/w320/${country.toLowerCase()}.png`
                }
                return `https://flagcdn.com/w320/${countryCode.toLowerCase()}.png`
            },
            getMade(team) {
                if (this.type === '2P') {
                    return team.twoPointsMade
                } else if (this.type === '3P') {
                    return team.threePointsMade
                } else if (this.type === '1P') {
                    return team.freeThrowsMade
                }
                return 0
            },
            getAttempts(team) {
                if (this.type === '2P') {
                    return team.twoPointAttempts
                } else if (this.type === '3P') {
                    return team.threePointAttempts
                } else if (this.type === '1P') {
                    return team.freeThrowAttempts
                }
                return 0
            }
        }
    }
</script>

<style>
    .v-progress-circular__info {
        display: block;
    }

    .circular-border {
        display: inline-flex;
        border: 2px solid #fff;     /* white border */
        border-radius: 50%;         /* make it circular */
        padding: 2px;               /* space between border and ring */
    }
</style>
